import { AuthConfig } from "angular-oauth2-oidc";
import { environment } from "src/environments/environment";

const Bases = {
  URL_PROVIDER: environment.IdpMasp + '/' + environment.appKeyMasp + '/',
  REDIRECT_URL: window.location.origin + '/gerenciar-login-masp',
  REDIRECT_URL_LOGOUT: window.location.origin + '/logout',
  SCOPES_AUTH: "openid profile",
  URL_TOKEN: environment.IdpMaspToken + '/' + environment.clientIdMasp,
  URL_LOGIN: environment.IdpMaspLogin,
  URL_LOGOUT: environment.IdpMaspLogout
};

export const authConfigMasp: AuthConfig = {
  issuer: Bases.URL_PROVIDER,
  redirectUri: Bases.REDIRECT_URL,
  //redirectUri: 'https://localhost:4200/gerenciar-login-masp',
  loginUrl: Bases.URL_LOGIN,
  tokenEndpoint: Bases.URL_TOKEN,
  postLogoutRedirectUri: Bases.REDIRECT_URL_LOGOUT,
  clientId: environment.clientIdMasp,
  responseType: 'code',
  scope: Bases.SCOPES_AUTH,
  showDebugInformation: true,
  logoutUrl: Bases.URL_LOGOUT
};


